module.exports = __webpack_public_path__ + "static/media/Allosense_Logo_Black.eaa3d4e2.png";